import { EdgeSendCrewInviteRepository } from '@/modules/auth/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { SendCrewInvite } from '@/modules/auth/use-cases'

export function makeSendCrewInvite(): SendCrewInvite {
  return new EdgeSendCrewInviteRepository(makeSupabaseEdgeHttpClient()).execute
}
